// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c8eb699a","718":"b6600544","812":"eef55b12"}[chunkId] + ".chunk.js";
};